import MegaModal from './MegaModal';
import { showLoader, hideLoader } from './loader';

function AgeVerification () {
    let intervalId;
    let sessionId;
    let eventSource;
    let modal;
    let consentSuccess = false;

    this.init = function () {
        const ageVerificationWarningContainer = document.getElementById('ageVerificationWarningContainer');

        if (!ageVerificationWarningContainer) {
            return;
        }

        const startButton = document.getElementById('startAgeVerificationFlowButton');
        startButton.addEventListener('click', postIdConsent);
    };

    function setSessionCounter (value) {
        sessionStorage.setItem('sessionCounter', JSON.stringify(value));
    }

    function getSessionCounter () {
        const currentSessionCounter = sessionStorage.getItem('sessionCounter');

        return Number(currentSessionCounter) || 0;
    }

    function updateSessionCount () {
        setSessionCounter(getSessionCounter() + 1);
    }

    function tryVerificationAgain (event) {
        if (getSessionCounter() === 5) {
            openModal(getLimitReachedModal());
            clearInterval(intervalId);
            return;
        }

        const tryAgainButton = event.target;
        const iFrame = document.getElementById('au10tixIframe');

        iFrame.src = 'about:blank';
        tryAgainButton.disabled = true;

        showLoader(tryAgainButton, { isSmall: true, isDark: true });

        if (!consentSuccess) {
            postIdConsent();
            return;
        }

        startAgeVerificationFlow();
    }

    function attachModalButtonsActions () {
        const tryAgainButtons = document.querySelectorAll("button[name='tryAgain']");

        if (tryAgainButtons) {
            tryAgainButtons.forEach(button => button.addEventListener('click', tryVerificationAgain));
        }
    }

    function detachModalButtonsActions () {
        const tryAgainButtons = document.querySelectorAll("button[name='tryAgain']");

        if (tryAgainButtons) {
            tryAgainButtons.forEach(button => button.removeEventListener('click', tryVerificationAgain));
        }
    }

    function getGeneralErrorModal () {
        return new MegaModal({
            modalType: 'receipt',
            content: '[general-error-modal-content]',
            clickOutsideToClose: 'false',
            closeBtn: 'false',
            afterShow: () => attachModalButtonsActions(),
            onHide: () => detachModalButtonsActions()
        });
    }
    function getLimitReachedModal () {
        return new MegaModal({
            modalType: 'receipt',
            content: '[limit-reached-modal-content]',
            clickOutsideToClose: 'false',
            closeBtn: 'false',
            afterShow: () => attachModalButtonsActions(),
            onHide: () => detachModalButtonsActions()
        });
    }

    function getVerificationFailedModal () {
        return new MegaModal({
            modalType: 'receipt',
            content: '[verification-failed-modal-content]',
            clickOutsideToClose: 'false',
            closeBtn: 'false',
            afterShow: () => attachModalButtonsActions(),

            onHide: () => detachModalButtonsActions()
        });
    }

    function openModal (currModal) {
        modal = currModal;
        modal.show();
    }

    function closeModal () {
        if (modal) {
            modal.hide();
            modal = null;
        }
    }

    function postIdConsent () {
        const startButton = document.getElementById('startAgeVerificationFlowButton');
        if (startButton) {
            startButton.disabled = true;
            showLoader(startButton, { isSmall: true, isDark: true });
        }

        const consentUrl = '/order/user-details/age-verification/customer-consent';
        const antiForgeryToken = document.querySelector('input[name="__RequestVerificationToken"]');
        const basketId = new URL(window.location.href).searchParams.get('basket');

        const consentOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `__RequestVerificationToken=${antiForgeryToken.value}&basketId=${basketId}`
        };

        fetch(consentUrl, consentOptions)
            .then(response => {
                if (!response || !response.ok) {
                    throw new Error('Something went wrong');
                }

                return response;
            })
            .then(() => {
                consentSuccess = true;

                startAgeVerificationFlow();
            })
            .catch(() => {
                if (startButton) {
                    startButton.disabled = false;
                    hideLoader(startButton);
                }

                openModal(getGeneralErrorModal());
                clearInterval(intervalId);
            });
    }

    function startAgeVerificationFlow () {
        const startButton = document.getElementById('startAgeVerificationFlowButton');

        if (getSessionCounter() >= 5) {
            openModal(getLimitReachedModal());
            clearInterval(intervalId);
            return;
        }

        const startSessionUrl = '/order/user-details/age-verification/init-session';
        const antiForgeryToken = document.querySelector('input[name="__RequestVerificationToken"]');

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `__RequestVerificationToken=${antiForgeryToken.value}`
        };

        fetch(startSessionUrl, options)
            .then(response => {
                if (!response || !response.ok) {
                    throw new Error('Something went wrong');
                }

                return response.json();
            })
            .then(data => {
                if (!data.VerificationSessionUrl || !data.SessionId) {
                    throw new Error('Something went wrong');
                }

                if (startButton) {
                    startButton.disabled = false;
                    hideLoader(startButton);
                }

                if (modal) {
                    const tryAgainButtons = document.querySelectorAll("button[name='tryAgain']");

                    tryAgainButtons.forEach(button => { button.disabled = false; hideLoader(button); });
                    closeModal();
                }

                const iFrameContainer = document.getElementById('iframeContainer');
                const ageVerificationWarningContainer = document.getElementById('ageVerificationWarningContainer');
                const iFrame = document.getElementById('au10tixIframe');

                ageVerificationWarningContainer.classList.add('is-hidden');
                iFrameContainer.classList.remove('is-hidden');

                iFrame.src = data.VerificationSessionUrl;
                eventSource = new URL(data.VerificationSessionUrl);
                eventSource = `${eventSource.protocol}//${eventSource.host}`;
                sessionId = data.SessionId;

                window.addEventListener('message', trackIFrameMessages, false);
                updateSessionCount();
            })
            .catch(() => {
                openModal(getGeneralErrorModal());
                clearInterval(intervalId);
            });
    }

    let isFetchingResults = false;
    let fetchCounter = 0;
    function getAgeVerificationResults () {
        if (isFetchingResults) {
            return;
        }

        isFetchingResults = true;
        fetchCounter += 1;

        if (fetchCounter > 20) {
            openModal(getGeneralErrorModal());
            window.removeEventListener('message', trackIFrameMessages, false);
            clearInterval(intervalId);
            return;
        }

        const ageVerificationResultsUrl = `/order/user-details/age-verification/get-session-results/${sessionId}`;

        fetch(ageVerificationResultsUrl)
            .then(response => {
                if (!response || !response.ok) {
                    throw new Error('Something went wrong');
                }

                return response.json();
            })
            .then(data => {
                if (!data.Status || data.Status === 'failed') {
                    throw new Error('Something went wrong');
                }

                isFetchingResults = false;

                if (data.Status === 'completed') {
                    const ageVerificationFailedStatus = data.FailedStatus;

                    if (ageVerificationFailedStatus) {
                        if (ageVerificationFailedStatus === 'errorUnderAge') {
                            openModal(getVerificationFailedModal());
                        } else if (ageVerificationFailedStatus === 'error') {
                            openModal(getGeneralErrorModal());
                        }

                        window.removeEventListener('message', trackIFrameMessages, false);
                        clearInterval(intervalId);
                        return;
                    }

                    consentSuccess = false;
                    window.location.replace(`${window.location.href}&avSessionId=${data.SessionId}`);

                    window.removeEventListener('message', trackIFrameMessages, false);
                    clearInterval(intervalId);
                } else if (data.Status === 'pending') {
                    isFetchingResults = false;
                }
            })
            .catch(() => {
                isFetchingResults = false;

                openModal(getGeneralErrorModal());

                window.removeEventListener('message', trackIFrameMessages, false);
                clearInterval(intervalId);
            });
    }

    function shouldOpenGeneralErrorModal (errorValue) {
        // timeout error values based on au10tix documentation which should trigger a generalErrorModal
        const validErrorValues = [6001, 4004, 4010];

        return validErrorValues.includes(errorValue);
    }

    function trackIFrameMessages (event) {
        if (event.origin === eventSource) {
            if (event.data.page === '/success' && event.data.type === 'routes') {
                setTimeout(() => {
                    intervalId = setInterval(getAgeVerificationResults, 3000);
                }, 3000);
            } else if (event.data.page !== '/success') {
                if (event.data.type === 'errors' || event.data.type === 'networkError') {
                    const errorValue = event.data.payload.value;

                    if (shouldOpenGeneralErrorModal(errorValue)) {
                        openModal(getGeneralErrorModal());
                        window.removeEventListener('message', trackIFrameMessages, false);
                    }
                }
            }
        }
    }
}

export default new AgeVerification();
